/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import _ from 'lodash';

import PlaceholderView from '../views/PlaceholderView';

/**
 * Takes a value, and returns whether that value represents a Promise.
 * @param {function} viewPromiseFunc a JavaScript function, that should return a promise, that should resolve into a Marionette view
 * @returns {Marionette.View} a placeholder view which will handle rendering the final view after the promise resolves
 * @example
 *
 * lazyLoadView(() => loadEntityCompliance({ entityId }))
 * -> a PlaceholderView instance with the viewPromise set.
 */
export default function lazyLoadView(viewPromiseFunc) {
  if (!_.isFunction(viewPromiseFunc)) {
    throw new Error('lazyLoadView expects a function as input');
  }
  const viewPromise = viewPromiseFunc();
  return new PlaceholderView({ viewPromise });
}
